module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av352-0ea5c95cd6595263762688206b49a960.jpg";